export default __webpack_public_path__ + "static/media/bankaccounts_3.adb5065b.png";